import { render, staticRenderFns } from "./PurchaseDetailImport.vue?vue&type=template&id=274ce3b6"
import script from "./PurchaseDetailImport.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports